/*
* Tabs
*/

function fnTabs(i, oSection) {

    var oSection = $(oSection);

    $(document).on('click', '.tab-title', function(ev){
        $('.tab-title').removeClass('is-active');
        $('.tab-panel').removeClass('is-active');
        $iIndex = $(this).index();

        $(this).addClass('is-active').index();
        $('.tab-panel').eq($iIndex).addClass('is-active');
/*        setTimeout(function () {
            locoScroll.update();
        }, 500)*/
        ev.preventDefault();
    });

}